import MetisMenu from "metismenujs";

// The metisMenu CSS transition lasts 350ms; anything past this means the
// transitionend event was lost.
export const TRANSITION_FALLBACK_MS = 500;

// MetisMenu clears its instance-wide isTransitioning flag only from a
// transitionend event. If a collapse animation starts while an ancestor is
// display:none (the login page hides #nav-display until Dashboard unhides it),
// the height goes 0px to 0px, no transition runs, the event never fires, and
// every later menu click is silently ignored until a full page reload.
// The same happens when React unmounts a submenu mid-animation.
// This subclass arms a fallback timer whenever a transition starts and, if the
// event goes missing, finishes the state machine by hand.
//
// Do not add class field declarations here: Babel initializes them after
// super() returns, which would wipe the guard armed during init().
class SafeMetisMenu extends MetisMenu {
  setTransitioning(isTransitioning) {
    super.setTransitioning(isTransitioning);
    if (this.transitionGuard) {
      clearTimeout(this.transitionGuard);
      this.transitionGuard = null;
    }
    if (isTransitioning) {
      this.transitionGuard = setTimeout(
        () => this.recoverStuckTransition(),
        TRANSITION_FALLBACK_MS,
      );
    }
  }

  recoverStuckTransition() {
    this.transitionGuard = null;
    const stuck = this.element.querySelectorAll("ul.mm-collapsing");
    stuck.forEach((ul) => {
      const li = ul.closest(this.config.parentTrigger);
      ul.classList.remove("mm-collapsing");
      ul.classList.add("mm-collapse");
      if (li && li.classList.contains("mm-active")) {
        ul.classList.add("mm-show");
      } else {
        ul.classList.remove("mm-show");
      }
      ul.style.height = "";
    });
    super.setTransitioning(false);
  }

  dispose() {
    if (this.transitionGuard) {
      clearTimeout(this.transitionGuard);
      this.transitionGuard = null;
    }
    super.dispose();
  }
}

export default SafeMetisMenu;
